/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2022-09-01 10:51:26
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-06-19 10:38:25
 */
import { Settings as ProSettings } from '@ant-design/pro-layout'

type DefaultSettings = ProSettings & {
  pwa: boolean
}

const proSettings: DefaultSettings = {
  navTheme: 'light',
  // 拂晓蓝
  primaryColor: '#0C997D',
  // #0C997D
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  menu: {
    locale: true
  },
  title: '五源投资管理',
  pwa: true,
  iconfontUrl: '/iconfont/iconfont.js'
}

export type { DefaultSettings }

export default proSettings
